// sagas.js
import { takeLatest, put, call } from 'redux-saga/effects';
import { fetchUserRoleSuccess, fetchUserRoleError, loginSuccess, loginError, loginWithOtpSuccess, loginWithOtpError, forgotPasswordSuccess, forgotPasswordError, resetPasswordSuccess, resetPasswordError, getUserProfileDetailsSuccess, getUserProfileDetailsError } from './action';
import { LoginOtp, checkLowWalletBalance, consumeResetPassword, getAllBrand, getAllCategory, getAllCompanys, getMyuserHasRole, getProfile, logoutUser, remember, requestResetPassword, userLogin } from '../../api';
import { FETCH_USER_ROLE, FORGOT_PASSWORD, GET_PROFILE, LOGIN, LOGIN_WITH_OTP, RESET_PASSWORD } from '../actionTypes';
import { getFromLocalStorage, setInLocalStorage } from '../../hooks/useLocalStorage';
import { makeid } from '../../services/data-encription';
import { getAllBrandsData, getAllBrandsDataSuccess, getAllCompaniesData, getAllCompaniesDataSuccess } from '../affiliations/action';
import { getAllCategoryRedux, getAllCategoryReduxSuccess, getCategoryForAll } from '../sales/action';
import moment from 'moment';
import { toast } from "react-toastify";
import Swal from 'sweetalert2';

function* fetchUserRoleSaga(action) {
  try {
    const { navigate } = action.payload;
    const user = JSON.parse(localStorage.getItem("user"))
    if (!user) {
      logoutUser(navigate)
    }
    const { data } = yield getMyuserHasRole(user.user_id);
    if (!data) {
      logoutUser(navigate)
    }
    const result = []
    data.result.forEach((ele) => {
      if (ele.is_active === true) {
        result.push(ele.role)
      }
    })
    if (result.length === 1) {
      localStorage.setItem("ROLE", JSON.stringify({ "name": result[0].name.toUpperCase(), "key": result[0].alias.toUpperCase(), "alias": result[0].alias, role_id: result[0].role_id, role_order: result[0].role_order }));
      navigate(`${process.env.PUBLIC_URL}/dashboard/default`);
    }
    else {
    }
    yield put(fetchUserRoleSuccess(result));
  } catch (error) {
    yield put(fetchUserRoleError(error));
  }
}

function* loginSaga(action) {
  const { userDetails, navigate, remember, toast, setLoading, showToast, setShowToast } = action.payload;
  const { email } = userDetails;

  try {
    const data = yield userLogin(userDetails);
    if (data) {
      yield put(loginSuccess(data.data.result.lastThreePhoneDigits));
      setInLocalStorage("isRememberMe", remember ? true : false)
      // navigate('/otp', { state: { email: email, remember, lastThreePhoneDigits: data.data?.msg } });
      navigate('/otp', { state: { email: email, remember, lastThreePhoneDigits: data.data.result.lastThreePhoneDigits, token: data.data.result.tokenForLogin } });
    }
  } catch (error) {   
    if (error.response.data.code == 413) {
      const temp = {
        email: error.response.data.result?.userEmail,
        phone_no: error.response.data.result?.phoneNo,
        result: error.response.data.result
      }
      navigate('/user/first-login', { state: temp });

    // } else if (error.response.data.code == 400 && error.response.data.error === "PASSWORD EXPIRED") {
    //   navigate("/login", {
    //     state: {
    //       showPasswordExpiredModal: true,
    //       expiredUserData: {
    //         email: userDetails.email,
    //         password: userDetails.password
    //       }
    //     }
    //   });

  } else if (error.response.data.code == 400 && error.response.data.error === "PASSWORD EXPIRED") {
    // Show toast
    if (!showToast) {
      setShowToast(true);
      toast.error("Your password has expired. Please update it.");
      setTimeout(() => {
        setShowToast(false);
      }, 6000);
    }
  
    // Navigate to login with modal
    navigate("/login", {
      state: {
        showPasswordExpiredModal: true,
        expiredUserData: {
          email: userDetails.email,
          password: userDetails.password
        }
      }
    });
  } else if (error.response.data.code == 500 && error.response.data.error === "OLD AND NEW PASSWORD CANNOT BE THE SAME") {
    // Show toast
    if (!showToast) {
      setShowToast(true);
      toast.error("Old and new password cannot be the same");
      setTimeout(() => {
        setShowToast(false);
      }, 6000);
    }

    // Navigate to login with modal
    navigate("/login", {
      state: {
        showPasswordExpiredModal: true,
        expiredUserData: {
          email: userDetails.email,
          password: userDetails.password
        }
      }
    });

  } else if (error.response.data.code == 500 && error.response.data.error === "Password policy update failed") {
    // Show toast
    if (!showToast) {
      setShowToast(true);
      toast.error("Password update failed. Please ensure your password meets the required policy.");
      setTimeout(() => {
        setShowToast(false);
      }, 6000);
    }
  
    // Navigate to login with modal
    navigate("/login", {
      state: {
        showPasswordExpiredModal: true,
        expiredUserData: {
          email: userDetails.email,
          password: userDetails.password
        }
      }
    });

  } else if (error.response.data.code == 500 && error.response.data.error === "Password must include at least one uppercase letter, one lowercase letter, one number, and one symbol.") {
    // Show toast
    if (!showToast) {
      setShowToast(true);
      toast.error("Password must include at least one uppercase letter, one lowercase letter, one number, and one symbol");
      setTimeout(() => {
        setShowToast(false);
      }, 6000);
    }
  
    // Navigate to login with modal
    navigate("/login", {
      state: {
        showPasswordExpiredModal: true,
        expiredUserData: {
          email: userDetails.email,
          password: userDetails.password
        }
      }
    });

  } else {
    setTimeout(() => {
      setLoading(false)
    }, [2000])

    if (!showToast) {
      setShowToast(true);
      const errorCode = error?.response?.data?.code;
      if (errorCode == 500){
        toast.error('Something went wrong');
      }else{
        toast.error(error?.response?.data?.error);
      }
      // toast.error(error?.response?.data?.msg);
      setTimeout(() => {
        setShowToast(false);
      }, 6000);
    }

    yield put(loginError(error));
  }
}
}

function* loginWithOtpSaga(action) {
  const { userOtpDetails, location, navigate, toast, setLoading, dispatch } = action.payload;
  try {
    // const {email, password} = userDetails
    // const { email, otp } = userOtpDetails
    const { email, otp, token, rememberMe } = userOtpDetails
    // const { data } = yield LoginOtp({ email, otp });
    // const { data } = yield LoginOtp({ email, otp, token });
    const { data } = yield LoginOtp({ email, otp, token, rememberMe });
    if (data) {
      setInLocalStorage("user", JSON.stringify(data.result.userData));
      setInLocalStorage("token", data.result.AuthorisationToken);
      setInLocalStorage("Name", data.result.userData.name);
      if (getFromLocalStorage("isRememberMe") == true || getFromLocalStorage("isRememberMe") == "true") {
        let browserId = makeid(26);
        setInLocalStorage("browserId", browserId)
        remember({ browser_id: browserId })
      }

      const res = yield getMyuserHasRole(data.result.userData.user_id);
      const result = []
      // console.log(data.result)
      res.data.result.forEach((ele) => {
        if (ele.is_active === true) {
          result.push(ele.role)
        }
      })
      yield put(loginWithOtpSuccess(data.result.userData));
      dispatch(getAllCompaniesData())
      // const getAllCategoryData = yield getAllCategory();
      // if (getAllCategoryData) {
      //   yield put(getAllCategoryReduxSuccess(getAllCategoryData.data?.result?.map((ele) => {
      //     return {
      //       sales_category_id: ele?.sales_category_id,
      //       name: ele?.name,
      //     }
      //   })));
      // }
      dispatch(getCategoryForAll())
      dispatch(getAllBrandsData())
      // const getAllBrandData = yield getAllBrand();
      // if (getAllBrandData) {
      //   yield put(getAllBrandsDataSuccess(getAllBrandData.data?.result?.brandDetails?.map((ele) => {
      //     return {
      //       brand_id: ele?.brand_id,
      //       name: ele?.name,
      //     }
      //   })));
      // }


      if (result.length === 1) {
        // setInLocalStorage("ROLE", JSON.stringify({ "name": result[0].name.toUpperCase(), "key": result[0].name.toUpperCase() }));
        setInLocalStorage("ROLE", JSON.stringify({ "name": result[0].name.toUpperCase(), "key": result[0].alias.toUpperCase(), "alias": result[0].alias, role_id: result[0].role_id, role_order: result[0].role_order }));

        if (navigate) {
          const TodayDate = moment(new Date()).format("YYYY-MM-DD");
          const lastLoginDetails = moment(getFromLocalStorage('user')?.lastLoginDetails?.created_at);
          const userLastLoginDetails = lastLoginDetails.format("YYYY-MM-DD");
          const wallet_closure_status = getFromLocalStorage('user')?.dealerInfo?.wallet_closure_status;
          const is_kyc_active = getFromLocalStorage('user')?.dealerInfo?.is_kyc_active;
          const is_KYC = getFromLocalStorage('user')?.dealerInfo?.is_KYC;
          const dealer_first_login = getFromLocalStorage('user')?.dealerInfo?.dealer_first_login;

          const salesCertificateURL = `${process.env.PUBLIC_URL}/sales/policies/certificate`;
          const defaultDashboardURL = `${process.env.PUBLIC_URL}/dashboard/default`;
          const dealership_id = getFromLocalStorage('user')?.dealerInfo?.dealership_id;

          if((getFromLocalStorage('ROLE')?.key == "DEALERSHIP_MANAGER") && !dealer_first_login){
            navigate(defaultDashboardURL);
          }else if ((getFromLocalStorage('ROLE')?.key == "DEALERSHIP_MANAGER") && (userLastLoginDetails !== TodayDate)) {
            if (wallet_closure_status == "ACTIVE" && is_kyc_active == true && is_KYC == true) {
                 checkLowWalletBalance(dealership_id)
                  .then((res) => {
                  }).catch((err) => {
                    console.log("Something went wrong")
                  });
                  navigate(defaultDashboardURL);
            } 
          }else if (((getFromLocalStorage('ROLE')?.key == "DEALERSHIP_MANAGER") || (getFromLocalStorage('ROLE')?.key == "DEALER_SALES_PERSON")) && (userLastLoginDetails === TodayDate)) {
            // navigate(`${process.env.PUBLIC_URL}/sales/policies/create/1`);
            if (wallet_closure_status == "ACTIVE" && is_kyc_active == true && is_KYC == true) {
              // navigate(`${process.env.PUBLIC_URL}/sales/policies/certificate`);
              navigate(salesCertificateURL);
            } else {
              navigate(defaultDashboardURL);
            }
          } else if(getFromLocalStorage("ROLE")?.key === "MIS") {
            navigate( `${process.env.PUBLIC_URL}/mis_reports/mis`);
          }else {
            navigate(defaultDashboardURL);
          }
        }
        // window.location.href = `${process.env.PUBLIC_URL}/dashboard/default`;
      }
      else {
        if (navigate) {
          navigate(`${process.env.PUBLIC_URL}/user/role`);
        }
        // window.location.href = `${process.env.PUBLIC_URL}/user/role`;
      }
    }

  } catch (error) {
    toast.error(error.response.data.error);
    if (setLoading) {
      setLoading(false);
    }
    yield put(loginWithOtpError(error));
  }
}

function* forgotPasswordSaga(action) {
  const { email, navigate, toast } = action.payload;
  try {

    yield requestResetPassword({ email: email }).then((res) => {
      toast.success(res.data.msg);
      navigate('/mail_sent', { state: { email: email } });
      put(forgotPasswordSuccess(res.data.msg));
    }).catch((error) => {
      toast.error(error.response?.data?.error);
      put(forgotPasswordError(error.response?.data?.error));
    });

  } catch (error) {
    toast.error(error.response.data.message);
    yield put(forgotPasswordError(error?.message));
  }
}

function* resetPasswordSaga(action) {
  try {
    const { newPassword, token, navigate, toast } = action.payload;

    const resp = yield consumeResetPassword({ newPassword: newPassword, token: token })
    if (resp) {
      const { data } = resp
      if (data) {
        toast.success(data.message);
        yield put(resetPasswordSuccess(data.message));
        yield call(() =>
          Swal.fire({
            icon: 'success',
            title: 'Password Reset',
            text: 'Your password has been successfully reset.',
          })
        );
        navigate('/login');
      }
    } else {
      toast.error('something went wrong');
    }
  } catch (error) {
    if (error.response && error.response.status === 400 && error.response.data && error.response.data.error) {
      toast.error(error.response.data.error);
    } else {
      toast.error('An error occurred');
    }
    yield put(resetPasswordError(error.message));
  }
}

function* getProfileSaga() {
  try {
    const resp = yield getProfile();
    if (resp) {
      yield put(getUserProfileDetailsSuccess(resp?.data?.result));
    }
  } catch (error) {
    yield put(getUserProfileDetailsError(error?.response?.data?.message));
  }
}

export function* watchLoginData() {
  yield takeLatest(FETCH_USER_ROLE, fetchUserRoleSaga);
  yield takeLatest(LOGIN, loginSaga);
  yield takeLatest(LOGIN_WITH_OTP, loginWithOtpSaga);
  yield takeLatest(FORGOT_PASSWORD, forgotPasswordSaga);
  yield takeLatest(RESET_PASSWORD, resetPasswordSaga);
  yield takeLatest(GET_PROFILE, getProfileSaga);
}

